import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class SuperAdminService extends BaseService {

  protected http: HttpClient;
  
  constructor(
    http: HttpClient, 
    tokenService: TokenService
  ) { 
    super(tokenService);
    this.http = http;
  }

  getAppTarget(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetAppTarget`);
  }

  getGeoTypeNameCropProgram(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetGeoTypeNameCropProgram`);
  }

  getGeoByType(geoName){
    return this.http.get<any>(`${environment.apiUrl}Department/GetGeoByType?GeoType=${geoName}`);
  }
  


  //post
  addModifyTargets(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Department/AddModifyTargets`, reqBody);
  }


  //delete
  deleteTargets(autoId:any){
    return this.http.post<any>(`${environment.apiUrl}Department/DeleteTargets?AutoId=${autoId}`, '');
  }

  getGeoUserMapping(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetUserGeoMapping`);
  }

  getGeoUserType(){
    return this.http.get<any>(`${environment.apiUrl}Department/GeoUserType`);
  }
  getUserActionFromUserType(value){
    return this.http.get<any>(`${environment.apiUrl}Department/GetUserActionFromUserType?UserType=${value}`);
  }
  addUpdateUserGeoMapping(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Department/AddUpdateUserGeoMapping`, reqBody);
  }

  deleteUserGeoMapping(autoId:any){
    return this.http.delete<any>(`${environment.apiUrl}Department/DeleteUserGeoMapping?AutoId=${autoId}`);
  }

  updateStatusUserGeoMapping(reqBody:any){
          return this.http.post<any>(`${environment.apiUrl}Department/UpdateStatusUserGeoMapping?AutoId=${reqBody.AutoId}&Active=${reqBody.Active}`, reqBody);
  }


  //user role api

  insertUserRole(reqBody: any) {
    return this.http.post(`${environment.apiUrl}Department/InsertUserRole`, reqBody, { responseType: 'text' });
  }
  

  //UserLogin Detail add

  InsertUserLoginDetail(reqBody: any) {
    return this.http.post(`${environment.apiUrl}Department/InsertUserLoginDetail`, reqBody, { responseType: 'text' });
  }
  


  getGetAllUserMaster() {
    return this.http.get<any>(`${environment.apiUrl}Department/GetAllUserMaster`);
  }

  getUserGeoMapping(userId: string) {
   
    return this.http.get<any>(`${environment.apiUrl}Department/GetUserGeoMapping?userID=${userId}`);
  }


getGetDistrictMaster() {
  return this.http.get<any>(`${environment.apiUrl}Department/GetDistrictMaster`);
}

GetBlockMaster(Dist_Code: string) {
  return this.http.get<any>(`${environment.apiUrl}Department/GetBlockMaster?Dist_Code=${Dist_Code}`);
}



GetVillageMaster(Dist_Code: string, Block_Code: string) {
  return this.http.get<any>(
    `${environment.apiUrl}Department/GetVillageMaster?Dist_Code=${Dist_Code}&Block_Code=${Block_Code}`
  );
}


GetActions() {
  return this.http.get<any>(`${environment.apiUrl}Department/GetActions`);
}



InsertUserLoginGeoMapping(reqBody: any) {
  return this.http.post(`${environment.apiUrl}Department/InsertUserLoginGeoMapping`, reqBody, {
    responseType: 'text'   // 👈 important: expect plain text
  });
}




// ✅ Update and deactivate geo mapping
UpdateUserGeoMapping(reqBody: any) {
  return this.http.post<any>(
    `${environment.apiUrl}Department/UpdateUserGeoMapping`,
    reqBody
  );
}

RegisteredUserGeoMapping(reqBody: any) {
  return this.http.post(`${environment.apiUrl}Department/RegisteredUserGeoMapping`, reqBody, { responseType: 'text' });
}


// ✅ Update and deactivate geo mapping


//get all user list excel
GetAllGeoMappings() {
  return this.http.get<any>(`${environment.apiUrl}Department/GetAllGeoMappings`);
}

//based on geoid 
getGeoDetailsByGeoID(geoCode: string) {
  return this.http.get<any>(`${environment.apiUrl}/Admin/GetGeoDetailsByGeoID?GeoID=${geoCode}`);
}


generateUserLogin(data: any) {
  return this.http.post<any>(`${environment.apiUrl}Department/GenerateUserLogin`, data);
}
insertOfficeOrder(data: any) {
  return this.http.post(`${environment.apiUrl}Department/InsertOfficeOrder`, data);
}


 // ✅ Insert Mapping API
 insertMapping(payload: any) {
  return this.http.post<any>(`${environment.apiUrl}Department/Insertmapping`, payload);
}


UpdateUserContact(body: any) {
  const url = `${environment.apiUrl}Department/UpdateUserContact`;
  console.log("📡 Calling API:", url, body);
  return this.http.post<any>(url, body);
}



InsertMapping(body: any) {
  return this.http.post<any>(`${environment.apiUrl}Department/Insertmapping`, body);
}


  // GET user lockout info
  searchUserLockout(userID: string){
    return this.http.get<any>(`${environment.apiUrl}/SearchUserIDLockout?userID=${userID}`);
  }

  // POST unlock user
unlockUser(userID: string) {
  return this.http.post(
    `${environment.apiUrl}/Department/UnLockUser?userID=${userID}`, 
    null, // no body
    { responseType: 'text' } // important
  );
}

  




}
